import { Link } from "react-router-dom";
import { type Role } from "../types/user";
import hanyangLogo from "../assets/images/hanyang-logo.png";
import { Navigation } from "./Navigation";
import { logout } from "../utils/loginUtils";
import { useIsMobile } from "../hooks/useMediaQuery";
import MobileDrawer from "./MobileDrawer";

import "./header.scss";

const Header = ({ role }: { role: Role }) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <div id="headerWrapper">
      <MobileDrawer role={role} />
    </div>
  ) : (
    <div id="headerWrapper">
      <div id="header">
        <Link to={`/${role}`}>
          <div className="horizontal">
            <img src={hanyangLogo} alt="홈" />
            {role === "staff" && <h4>사무국</h4>}
            {role === "instructor" && <h4>지도자</h4>}
          </div>
        </Link>
        <div className="horizontal">
          <p>{sessionStorage.getItem("name")}님, 환영합니다.</p>
          <button onClick={logout}>로그아웃</button>
        </div>
      </div>
      <Navigation role={role} />
    </div>
  );
};

export default Header;
